// Manual KYC Action Constants

export const SEARCH_USERS_KYC_REQUEST = 'SEARCH_USERS_KYC_REQUEST'
export const SEARCH_USERS_KYC_SUCCESS = 'SEARCH_USERS_KYC_SUCCESS'
export const SEARCH_USERS_KYC_FAIL = 'SEARCH_USERS_KYC_FAIL'

export const GET_PENDING_KYC_REQUEST = 'GET_PENDING_KYC_REQUEST'
export const GET_PENDING_KYC_SUCCESS = 'GET_PENDING_KYC_SUCCESS'
export const GET_PENDING_KYC_FAIL = 'GET_PENDING_KYC_FAIL'

export const GET_KYC_DETAILS_REQUEST = 'GET_KYC_DETAILS_REQUEST'
export const GET_KYC_DETAILS_SUCCESS = 'GET_KYC_DETAILS_SUCCESS'
export const GET_KYC_DETAILS_FAIL = 'GET_KYC_DETAILS_FAIL'
export const GET_KYC_DETAILS_RESET = 'GET_KYC_DETAILS_RESET'

export const UPLOAD_KYC_DOCUMENT_REQUEST = 'UPLOAD_KYC_DOCUMENT_REQUEST'
export const UPLOAD_KYC_DOCUMENT_SUCCESS = 'UPLOAD_KYC_DOCUMENT_SUCCESS'
export const UPLOAD_KYC_DOCUMENT_FAIL = 'UPLOAD_KYC_DOCUMENT_FAIL'

export const SUBMIT_MANUAL_KYC_REQUEST = 'SUBMIT_MANUAL_KYC_REQUEST'
export const SUBMIT_MANUAL_KYC_SUCCESS = 'SUBMIT_MANUAL_KYC_SUCCESS'
export const SUBMIT_MANUAL_KYC_FAIL = 'SUBMIT_MANUAL_KYC_FAIL'

export const APPROVE_MANUAL_KYC_REQUEST = 'APPROVE_MANUAL_KYC_REQUEST'
export const APPROVE_MANUAL_KYC_SUCCESS = 'APPROVE_MANUAL_KYC_SUCCESS'
export const APPROVE_MANUAL_KYC_FAIL = 'APPROVE_MANUAL_KYC_FAIL'

export const REJECT_MANUAL_KYC_REQUEST = 'REJECT_MANUAL_KYC_REQUEST'
export const REJECT_MANUAL_KYC_SUCCESS = 'REJECT_MANUAL_KYC_SUCCESS'
export const REJECT_MANUAL_KYC_FAIL = 'REJECT_MANUAL_KYC_FAIL'
